
import { NO_INFORMATION } from "@/data/placeholders";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PageHeadIcon extends Vue {
  @Prop({ type: String, default: undefined }) readonly icon?: string;
  @Prop({ type: String, default: undefined }) readonly content?: string;
  @Prop({ type: String, default: undefined }) readonly title?: string;
  @Prop({ type: Boolean, default: false }) readonly extend!: boolean;

  noInformaion = NO_INFORMATION;

  get contentData(): string {
    if (this.content) {
      return this.content;
    }
    return this.noInformaion;
  }

  get contentStyles(): Object {
    if (this.content) {
      return {
        truncate: !this.extend,
        "block -mr-3 break-all": this.extend,
      };
    }
    return {};
  }
  handleClick() {
    if (this.isEmailValid(this.contentData)) {
      window.location.href = `mailto:${this.contentData}`;
    } else if (this.isPhoneNumber(this.contentData)) {
      window.location.href = `tel:${this.contentData}`;
    }
  }

  isLink(data) {
    return this.isEmailValid(data) || this.isPhoneNumber(data);
  }

  isEmailValid(email) {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    return emailRegex.test(email);
  }

isPhoneNumber(phone) {
  const isPhone = /(\+?1)?\d{10}(\s*(ext|x|ext.)\s*\d+)?/;
  return isPhone.test(phone);
}


}
